/*
 * Keep the cart UI honest without opening it — design direction test (task 19059).
 *
 * The quick shop panel and Shop the look both add to the bag while deliberately leaving
 * the cart drawer shut, so the shopper keeps browsing. The drawer and cart icon are
 * rendered server-side at page load, so without this they keep showing the cart as it
 * was when the page loaded — "Your cart is empty" even after an add.
 *
 * Dawn's own cart-drawer.renderContents() updates AND opens, which is exactly what we
 * don't want here, so the sections are re-rendered directly instead.
 */
window.dtRefreshCart = async function dtRefreshCart() {
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('cart-drawer');
  const bubble = document.getElementById('cart-icon-bubble');
  const counts = document.querySelectorAll('[data-bag-count]');

  try {
    const [cart, sectionsResponse] = await Promise.all([
      fetch(`${root}cart.js`).then((r) => r.json()),
      fetch(`${root}?sections=cart-drawer,cart-icon-bubble`).then((r) => r.json()),
    ]);

    counts.forEach((el) => {
      el.textContent = cart.item_count;
    });

    const parse = (html, selector) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      return doc.querySelector(selector);
    };

    if (drawer && sectionsResponse['cart-drawer']) {
      const fresh = parse(sectionsResponse['cart-drawer'], 'cart-drawer');
      if (fresh) {
        drawer.innerHTML = fresh.innerHTML;
        // The empty state is a class on the element itself, so it has to be carried
        // across separately or the drawer keeps saying the cart is empty.
        drawer.classList.toggle('is-empty', cart.item_count === 0);

        // Replacing the contents above destroyed whatever had focus. Put it back
        // inside the drawer while it is open, so the keyboard still works there.
        if (drawer.classList.contains('active')) {
          drawer.querySelector('.drawer__inner')?.focus();
        }
      }
    }

    // The whole counter is replaced, not just its number. On an empty cart Dawn renders
    // no .cart-count-bubble at all, so swapping an existing one silently did nothing on
    // the first add of a session - the drawer filled up while the header still read
    // "Cart". Headers that keep their own [data-bag-count] are left alone; the loop
    // above has already updated those.
    // The id cart-icon-bubble belongs to the <a> in the header, not to anything inside
    // the rendered section - that arrives wrapped in #shopify-section-cart-icon-bubble.
    // Looking for the former found nothing and the counter never moved. Taking the
    // section wrapper's contents also covers an empty cart, where Dawn renders no
    // .cart-count-bubble at all and there is nothing to swap.
    const ownsCount = bubble && bubble.querySelector('[data-bag-count]');
    if (bubble && !ownsCount && sectionsResponse['cart-icon-bubble']) {
      const fresh =
        parse(sectionsResponse['cart-icon-bubble'], '#shopify-section-cart-icon-bubble') ||
        parse(sectionsResponse['cart-icon-bubble'], 'body');
      if (fresh) bubble.innerHTML = fresh.innerHTML;
    }

    // The upsell inside the drawer was just replaced, so anything holding state about it
    // needs to recompute - on a phone that is how many bracelets fit on a page.
    document.dispatchEvent(new CustomEvent('cart:refreshed'));

    return cart;
  } catch (error) {
    console.log(`cart refresh: ${error.message}`);
    return null;
  }
};
